import api from "./core";

const basePath = "api/core/";

export default {
  get(path, id) {
    return api.get(`${basePath}${path}/${id}`);
  },
  update(path, id, data) {
    return api.patch(`${basePath}${path}/${id}`, data);
  },
  delete(path, id) {
    return api.delete(`${basePath}${path}/${id}`);
  },
  query(path, data) {
    return api.post(`${basePath}${path}`, data);
  },
  count(path, data) {
    return api.post(`${basePath}${path}/SearchCount`, data);
  },
  create(path, data) {
    return api.put(`${basePath}${path}`, data);
  },
  reorder(path, data) {
    return api.post(`${basePath}${path}/Sort`, data);
  }
};
